import type { PlannedSquadPayload } from './api';

export interface PlannedSquadHydrationResult {
  plan: PlannedSquadPayload | null;
  source: 'SERVER' | 'LOCAL' | 'NONE';
}

/**
 * Initial PREVIEW hydration rule:
 * - a valid server-saved plan for the selected GW is authoritative;
 * - otherwise keep a same-GW local draft;
 * - never hydrate a plan from another GW.
 *
 * App.tsx applies this only once per entry/GW, so later unsaved browser edits
 * are not continuously overwritten by the server copy.
 */
export function chooseInitialPlannedSquad(
  localPlan: PlannedSquadPayload | null | undefined,
  serverPlan: PlannedSquadPayload | null | undefined,
  targetGameweek: number,
): PlannedSquadHydrationResult {
  if (serverPlan?.gameweek === targetGameweek) return { plan: serverPlan, source: 'SERVER' };
  if (localPlan?.gameweek === targetGameweek) return { plan: localPlan, source: 'LOCAL' };
  return { plan: null, source: 'NONE' };
}
